import { css } from '@emotion/react';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type ContactSideInformationProps = {
  className?: string;
  titleEn: string;
  titleJa: string;
  items: string[];
};

export const ContactSideInformation: React.FC<ContactSideInformationProps> = ({
  className,
  titleEn,
  titleJa,
  items,
}) => {
  return (
    <div
      css={css`
        background: linear-gradient(
          180deg,
          #f0fcfb 0%,
          #f8fffe 49%,
          #ffffff 100%
        );
        padding: 64px 40px 72px;
        margin: 80px -30px 0;
        overflow: hidden;

        @media ${getScreen('pc')} {
          position: absolute;
          left: calc(50% - 138px);
          top: 110px;
          z-index: -1;
          width: 775px;
          max-width: calc(100% - 337px);
          height: calc(100% - 140px);
          margin: 0;
          padding: 100px 64px 0 338px;
        }
      `}
      className={className}
    >
      <div>
        <p
          css={css`
            font-size: 1.4rem;
            line-height: 1.8rem;
            letter-spacing: 2.52px;
            font-weight: bold;
            color: #00b3a7;
            display: flex;
            align-items: center;
            gap: 12px;
            font: normal normal bold 14px/18px 'din-2014-narrow', sans-serif;
            letter-spacing: 2.52px;
            color: #00b3a7;

            &::after {
              content: '';
              display: block;
              background-color: #00b3a7;
              height: 1px;
              flex: 1 1 100%;
              max-width: 100px;
            }
          `}
        >
          {titleEn}
        </p>
        <h2
          css={css`
            font: normal normal bold 21px/30px 'Noto Sans JP', sans-serif;
            letter-spacing: 1.26px;
            color: #00b3a7;
            margin-top: 11px;
          `}
        >
          {titleJa}
        </h2>
      </div>
      <ul
        css={css`
          margin-top: 16px;
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 10px;
        `}
      >
        {items.map((item, i) => (
          <li
            key={i}
            css={css`
              padding-inline-start: 23px;
              position: relative;
              font: normal normal normal 14px/20px 'Noto Sans JP', sans-serif;
              letter-spacing: 0.45px;
              color: #5a5b6a;

              &::before {
                content: '';
                display: block;
                background-image: url(${withPrefix('/images/contact-check-icon.svg')});
                background-size: contain;
                width: 15px;
                height: 15px;
                position: absolute;
                left: 0;
                top: 4px;
              }
            `}
          >
            {item}
          </li>
        ))}
      </ul>
      <div
        css={css`
          margin-top: 40px;

          @media ${getScreen('pc')} {
            margin-top: 50px;
          }
        `}
      >
        <img
          css={css`
            margin: -18px;
          `}
          src={withPrefix('/images/contact/side-image.png')}
          width="405"
          height="304"
          alt=""
        />
      </div>
    </div>
  );
};
